<script setup lang="ts">

import { usePresentation } from '@/modules/Presentation/Types';
import { useLead } from "../../Types/Lead";
import { Outcome } from '../../Types/LeadOptions';

const lead = useLead();
const presentation = usePresentation();

presentation.backgroundImage = '/images/sample/gkr-watermark.png';

</script>

<template>

    <Page>

        <div class="flex flex-col gap-4 w-full text-xl px-20">

            <div class="fixed right-4 bottom-4 text-xs">
                <div class="uppercase">Lead Data</div>
                <pre>{{ lead }}</pre> 
            </div>
            
            <p class="text-3xl font-semibold mb-4 text-center">
                <span v-if="lead.outcome == Outcome.signup">
                    Let’s get you booked in for your first class!
                </span>
                <span v-else-if="lead.outcome == Outcome.thinkAboutIt">
                    The information pack has been sent to you, hope to hear from you soon!
                </span>
                <span v-else>
                    Thank you for your time, we're always here if you change your mind
                </span>
            </p>

            <div class="flex gap-6 justify-center">

                <TouchButton
                    @click="() => presentation.reset()">
                    Thank you!
                </TouchButton>

            </div>
            
        </div>

    </Page>

</template>